module.exports = {
  title: 'shake-to-delete',
  author: 'Enzo Manuel Mangano',
  date: '2025-02-05',
  slug: 'shake-to-delete',
  tags: ['reanimated'],
};
